import { render, staticRenderFns } from "./ExpCommissionQuestions.vue?vue&type=template&id=a45fb134&scoped=true"
import script from "./ExpCommissionQuestions.vue?vue&type=script&lang=js"
export * from "./ExpCommissionQuestions.vue?vue&type=script&lang=js"
import style0 from "./ExpCommissionQuestions.vue?vue&type=style&index=0&id=a45fb134&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45fb134",
  null
  
)

export default component.exports